import { IDENTITY_SELFIE_SOURCE } from '../../../constants/identity';

export const IDENTITIES_COMMANDERING_URL = '/admin/css/identities/command';

export const ADMIN_CSS = {
  ALBUM_MONITORING_PER_PAGE: 50,
  IDENTITIES_MONITORING_PER_PAGE: 50,
  ASSIGNED_TO_DEFAULT_VALUE: 'all',
  DATE_STATUS_ALL_VALUE: 'all',
  COMMANDER_ENABLED_TO_DEFAULT_VALUE: 'n/a',
  DEFAULT_SMS_IDENTITY_SELFIE_REQUEST_MESSAGE: `Hi, Waldo here! It looks like I need a stronger reference photo of {name}. Let's fix that! Please upload a recent photo in the Waldo app here: {link}`,
  DEFAULT_SMS_GENERAL_SELFIE_REQUEST: `Looks like I still need a stronger reference photo of {name}. Let's fix that! Please this reply this message with a recent photo. Don’t worry about your hair - I’m just a robot ;) - Waldo`,
  ACTIVE_REF_LIMIT: 3,
};

export const ALBUM_DATE_STATUS = {
  MONITORING_ACTIVE: 'MONITORING_ACTIVE',
  MONITORING_INACTIVE: 'MONITORING_INACTIVE',
  NO_DATE: 'NO_DATE',
};

export const WEB_GALLERY_STATUS = {
  ALL: 'ALL',
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
};

export const PURCHASED_IDENTITY_STATUS = {
  ALL: 'ALL',
  PURCHASED: 'PURCHASED',
  NON_PURCHASED: 'NON_PURCHASED',
};

export const SORT_DIRECTION = {
  DESC: 'DESC',
  ASC: 'ASC',
};

export const ALBUM_MONITORING_SORT_OPTIONS = {
  ALBUM_NAME: 'ALBUM_NAME',
  ALBUM_START_DATE: 'ALBUM_START_DATE',
  ALBUM_END_DATE: 'ALBUM_END_DATE',
  ALBUM_PHOTOS_COUNT: 'ALBUM_PHOTOS_COUNT',
  ALBUM_MAYBES_COUNT: 'ALBUM_MAYBES_COUNT',
  ALBUM_UNFLUSHED_COUNT: 'ALBUM_UNFLUSHED_COUNT',
  ALBUM_ENROLLED_COUNT: 'ALBUM_ENROLLED_COUNT',
  ALBUM_LAST_UPLOAD_DATE: 'ALBUM_LAST_UPLOAD_DATE',
  ALBUM_NOT_SURE_MAYBES_COUNT: 'ALBUM_NOT_SURE_MAYBES_COUNT',
  ALBUM_MATCHES_COUNT: 'ALBUM_MATCHES_COUNT',
  ALBUM_REMAINING_DAYS: 'ALBUM_REMAINING_DAYS',
  ACCOUNT_ORGANIZATION: 'ACCOUNT_ORGANIZATION',
  ALBUM_MATCHES_PER_IDENTITY: 'ALBUM_MATCHES_PER_IDENTITY',
  ALBUM_DELIVERED_MATCHED_PHOTOS_PER_IDENTITY:
    'ALBUM_DELIVERED_MATCHED_PHOTOS_PER_IDENTITY',
  ALBUM_FLUSHABLE_NOT_SURE_COUNT: 'ALBUM_FLUSHABLE_NOT_SURE_COUNT',
};

export const ALBUM_MONITORING_SORT_OPTIONS_FIELD_NAMES = {
  ALBUM_NAME: 'Album Name',
  ALBUM_START_DATE: 'Start Date',
  ALBUM_END_DATE: 'End Date',
  ALBUM_PHOTOS_COUNT: '# of Photos',
  ALBUM_MAYBES_COUNT: '# of Maybes',
  ALBUM_UNFLUSHED_COUNT: '# of Flushable',
  ALBUM_ENROLLED_COUNT: '# of Identities Enrolled',
  ALBUM_LAST_UPLOAD_DATE: 'Last Upload Date',
  ALBUM_NOT_SURE_MAYBES_COUNT: '# of Not Sure',
  ALBUM_FLUSHABLE_NOT_SURE_COUNT: '# of Flusher Not Sure',
  ALBUM_MATCHES_COUNT: '# of Matches',
  ALBUM_REMAINING_DAYS: '# of Remaining Days',
  ACCOUNT_ORGANIZATION: 'Account Organization Name',
  ALBUM_MATCHES_PER_IDENTITY: '# of Matches / Identity',
  ALBUM_DELIVERED_MATCHED_PHOTOS_PER_IDENTITY: '# of Deliveries / Identity',
};

export const SELECTED_IDENTITIES_MONITORING_SORT_OPTIONS = {
  IDENTITY_NAME: 'IDENTITY_NAME',
  IDENTITY_JOINED_DATE: 'IDENTITY_JOINED_DATE',
  ACCOUNT_CREATED_AT: 'ACCOUNT_CREATED_AT',
  IDENTITY_LAST_NAME: 'IDENTITY_LAST_NAME',
  ACCOUNT_EMAIL: 'ACCOUNT_EMAIL',
  ACCOUNT_PHONE: 'ACCOUNT_PHONE',
  ALBUM_NAME: 'ALBUM_NAME',
  MATCHED_PHOTOS_COUNT: 'MATCHED_PHOTOS_COUNT',
  MAYBES_COUNT: 'MAYBES_COUNT',
  NOT_EVEN_CLOSE_COUNT: 'NOT_EVEN_CLOSE_COUNT',
  MAYBES_NOT_SURE_COUNT: 'MAYBES_NOT_SURE_COUNT',
  DELIVERED_MATCHED_PHOTOS_COUNT: 'DELIVERED_MATCHED_PHOTOS_COUNT',
  DELIVERED_MATCHED_PHOTOS_COUNT_PER_DAY:
    'DELIVERED_MATCHED_PHOTOS_COUNT_PER_DAY',
  POSITIVE_APPLIED_MACHINE_COUNT: 'POSITIVE_APPLIED_MACHINE_COUNT',
  POSITIVE_UNAPPLIED_COUNT: 'POSITIVE_UNAPPLIED_COUNT',
  POSITIVE_UNAPPLIED_FLUSHER_NOT_SURE_COUNT:
    'POSITIVE_UNAPPLIED_FLUSHER_NOT_SURE_COUNT',
  SELFIES_COUNT: 'SELFIES_COUNT',
  USER_SELFIES_COUNT: 'USER_SELFIES_COUNT',
  ASSIGNED_SELFIES_COUNT: 'ASSIGNED_SELFIES_COUNT',
  LAST_DELIVERED_MATCHED_PHOTO: 'LAST_DELIVERED_MATCHED_PHOTO',
  NOTES_COUNT: 'NOTES_COUNT',
  CONSUMER_VOTES_COUNT: 'CONSUMER_VOTES_COUNT',
  CONSUMER_VOTES_POSITIVE_COUNT: 'CONSUMER_VOTES_POSITIVE_COUNT',
  CONSUMER_VOTES_NEGATIVE_COUNT: 'CONSUMER_VOTES_NEGATIVE_COUNT',
  ALBUM_REMAINING_DAYS: 'ALBUM_REMAINING_DAYS',
  DELIVERED_MATCHED_PHOTOS_OVER_ALBUM_TOTAL:
    'DELIVERED_MATCHED_PHOTOS_OVER_ALBUM_TOTAL',
  REFERENCE_FACES_COUNT: 'REFERENCE_FACES_COUNT',
  USER_REFERENCE_FACES_COUNT: 'USER_REFERENCE_FACES_COUNT',
  ASSIGNED_REFERENCE_FACES_COUNT: 'ASSIGNED_REFERENCE_FACES_COUNT',
};

export const SELECTED_IDENTITIES_MONITORING_SORT_OPTIONS_FIELD_NAMES = {
  IDENTITY_NAME: 'Identity Name',
  IDENTITY_LAST_NAME: 'Identity Last Name',
  IDENTITY_JOINED_DATE: 'Identity Joined At',
  ACCOUNT_EMAIL: 'Account Email',
  ACCOUNT_PHONE: 'Account Phone',
  ACCOUNT_CREATED_AT: 'Account Created At',
  ALBUM_NAME: 'Album Name',
  MATCHED_PHOTOS_COUNT: '# of Matches',
  MAYBES_COUNT: '# of Maybes',
  NOT_EVEN_CLOSE_COUNT: '# of NEC',
  MAYBES_NOT_SURE_COUNT: '# of Matcher Not Sure (MNS)',
  DELIVERED_MATCHED_PHOTOS_COUNT: '# of Deliveries',
  DELIVERED_MATCHED_PHOTOS_COUNT_PER_DAY: '# of Deliveries Per Day',
  POSITIVE_APPLIED_MACHINE_COUNT: '# of Autoflown Matches',
  POSITIVE_UNAPPLIED_COUNT: '# of Flushable',
  POSITIVE_UNAPPLIED_FLUSHER_NOT_SURE_COUNT: '# of Flushable Not Sure (FNS)',
  REFERENCE_FACES_COUNT: '# of Reference faces',
  USER_REFERENCE_FACES_COUNT: '# of Reference faces Provided by the User',
  ASSIGNED_REFERENCE_FACES_COUNT: '# of Reference faces Assigned',
  LAST_DELIVERED_MATCHED_PHOTO: 'Last Delivery Date',
  NOTES_COUNT: '# of Notes',
  CONSUMER_VOTES_COUNT: 'Number of Consumer Tags + Untags',
  CONSUMER_VOTES_POSITIVE_COUNT: 'Number of Consumer Tags',
  CONSUMER_VOTES_NEGATIVE_COUNT: 'Number of Consumer Untags',
  ALBUM_REMAINING_DAYS: '# of Remaining Days',
  DELIVERED_MATCHED_PHOTOS_OVER_ALBUM_TOTAL: 'Identities / Album Deliveries',
};

export const ADMIN_CSS_COMMANDERING_VETO_VOTE_TYPE = {
  NOT_SURE_MAYBE: 'NOT_SURE_MAYBE',
  NOT_SURE_FLUSHABLE: 'NOT_SURE_FLUSHABLE',
  FLUSHABLE: 'FLUSHABLE',
  FLUSHED: 'FLUSHED',
  MAYBE: 'MAYBE',
  NOT_EVEN_CLOSE: 'NOT_EVEN_CLOSE',
};

/**
 * Selfie Count Display Options.
 *
 * @enum {{ALL: string, USER_PROVIDED: string, ASSIGNED: string}}
 */
export const IDENTITIES_SELFIE_COUNT_DISPLAY = {
  ALL: 'ALL',
  USER_PROVIDED: 'USER_PROVIDED',
  ASSIGNED: 'ASSIGNED',
};

export const IDENTITIES_TABLE_VALUES = {
  TOTAL_USER_SELFIES: '# User Selfies',
  TOTAL_ASSIGNED_USER_SELFIES: '# Assigned Selfies',
  TOTAL_USER_PROVIDED_USER_SELFIES: '# User Provided Selfies',
  ALBUM_REMAINING_DAYS: '# Remaining Days',
  TOTAL_MATCHES: '# Matches',
  TOTAL_FLUSHED: '# Flushed',
  TOTAL_FLUSHABLE: '# Flushable',
  TOTAL_MAYBES: '# Maybes',
  TOTAL_MNS: '# Matcher Not Sure',
  TOTAL_FNS: '# Flusher Not Sure',
  TOTAL_NEC: '# NEC',
  TOTAL_CONSUMER_VOTES: '# Consumer Votes',
  TOTAL_CONSUMER_POSITIVE_VOTES: '# Consumer Tags',
  TOTAL_CONSUMER_NEGATIVE_VOTES: '# Consumer Untags',
  TOTAL_DELIVERIES: '# Deliveries',
  LAST_DELIVERY_DATE: 'Last Delivery Date',
  TOTAL_DELIVERIES_PER_DAY: '# Deliveries/Day',
  AVERAGE_IDENTITY_ALBUM_DELIVERIES: 'Id/Album Deliveries',
};

export const SELECTED_IDENTITY_LINK_FILTER = {
  ALL: 'ALL',
  NOT_CLONE: 'NOT_CLONE',
  SOURCE: 'SOURCE',
  CLONE: 'CLONE',
};

export const JOIN_CODE_FILTER = {
  ALL: 'ALL',
  WITH_JOIN_CODE: 'WITH_JOIN_CODE',
  WITHOUT_JOIN_CODE: 'WITHOUT_JOIN_CODE',
};

/**
 * Reference Faces Display Options.
 *
 * @enum {{ALL: string, ADMIN_PROMOTED_FROM_MATCH: string, ADMIN_UPLOADED: string, AUTORIPS: string, GLOBAL_AUTORIPS: string, ROSTER_IDENTITY: string, USER_UPLOADED: string}}
 */
export const REFERENCE_FACES_SOURCE_FILTER = {
  ALL: 'ALL',
  ...IDENTITY_SELFIE_SOURCE,
};

/**
 * Album delivery mode filter
 *
 * @type {{PPA: string, SHUTTERBUG: string, ALL: string, INTERNAL: string, FREE_WEB_GALLERY: string, PHOTO_FINDER: string}}
 */
export const ALBUM_DELIVERY_MODE_FILTER = {
  ALL: 'ALL',
  FREE_WEB_GALLERY: 'FREE_WEB_GALLERY',
  INTERNAL: 'INTERNAL',
  PHOTO_FINDER: 'PHOTO_FINDER',
  PPA: 'PPA',
  SHUTTERBUG: 'SHUTTERBUG',
};
